// Maps a partner service to the DataCentral `product_groups` vocabulary. A lead's
// interested service (the CRM "Giải pháp" field) is a fixed product-group dropdown
// — sending a raw partner display name (e.g. "Managed Kubernetes") matches no
// option and renders blank. Send the canonical product-group name instead so the
// lead's interested service is selectable and reportable.
//
// Vocabulary source of truth: `product_groups` table in DataCentral (verified
// live). Only names present there are valid.

/** Canonical product-group names (subset used by the self-serve catalog). */
export const PRODUCT_GROUP = {
  cloudService: 'CLOUD SERVICE',
  storage: 'STORAGE',
  cdn: 'CONTENT DELIVERY NETWORK',
  waap: 'WAF V2',
  waf: 'VNIS',
  media: 'TRANSCODING',
  ssl: 'SSL',
} as const;

// Provider scope (categories.ts) → product group. Compute/K8s/VMware/Functions/
// Registry/DB are all sold as "CLOUD SERVICE"; the media codecs collapse to
// "TRANSCODING"; WAAP→WAF V2 but the CDN-integrated WAF→VNIS.
const SCOPE_TO_GROUP: Record<string, string> = {
  'Internal.Opennebula': PRODUCT_GROUP.cloudService,
  'Internal.Opennebula.Kubernetes': PRODUCT_GROUP.cloudService,
  'Internal.Opennebula.Database': PRODUCT_GROUP.cloudService,
  'Internal.VMware': PRODUCT_GROUP.cloudService,
  'Internal.Functions': PRODUCT_GROUP.cloudService,
  'Internal.ContainerRegistry': PRODUCT_GROUP.cloudService,
  'Internal.Minio': PRODUCT_GROUP.storage,
  'External.Mlytics': PRODUCT_GROUP.cdn,
  'Security.WAAP': PRODUCT_GROUP.waap,
  'Security.WAF': PRODUCT_GROUP.waf,
  'Security.Certificates': PRODUCT_GROUP.ssl,
  'Internal.FastChannel': PRODUCT_GROUP.media,
  'Internal.HLSLowLatency': PRODUCT_GROUP.media,
  'External.SwiftCoder': PRODUCT_GROUP.media,
  'Internal.Transcoding': PRODUCT_GROUP.media,
  'Internal.Aes': PRODUCT_GROUP.media,
};

/** Product group for a provider scope, or undefined when the scope isn't mapped. */
export function leadProductGroupForScope(scope: string | undefined): string | undefined {
  return scope ? SCOPE_TO_GROUP[scope] : undefined;
}
